<template>
	<div class="topic_change">
		<div class="container-fluid">
			<!-- Begin page -->
			<div class="wrapper">
				<div class="content-page">
					<div class="content">
						<div class="row">
							<div class="col-12">
								<div class="page-title-box">
									<div class="page-title-right"><Breadcrumb /></div>
									<h3 class="header-title mb-3">课题变更</h3>
								</div>
								<!-- end page-title-box -->
							</div>
							<!-- end col-->
						</div>

						<div class="row">
							<div class="col-12">
								<div class="card">
									<div class="card-body">
										
										<div class="review_list" v-show="!isShowReviewDetail">
											<ul class="tabs_wrap">
												<li class="tab_item" :class="{active:index == curTabIndex}" @click="tabChange(index)" v-for="(item,index) in tabList" :key="index">{{item}}</li>
											</ul>
											<el-form ref="reviewListParamsRef" :model="reviewListParams" label-width="0px">
												<el-row :gutter="10">
													<el-col :span="3">
														<el-form-item><el-input clearable placeholder="课题名称,负责人,学校" v-model="reviewListParams.keyword"></el-input></el-form-item>
													</el-col>
													<el-col :span="3">
														<el-form-item>
															<el-cascader
																v-model="reviewListParams.keywordId"
																:options="TopicLevelTypeList"
																:props="{ checkStrictly: true, value: 'id', label: 'name' }"
																placeholder="课题级别类别"
																clearable
															></el-cascader>
														</el-form-item>
													</el-col>
													<!-- <el-col :span="3">
														<el-form-item>
															<el-select v-model="reviewListParams.learningType" clearable placeholder="所属学段">
																<el-option v-for="item in learningTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
															</el-select>
														</el-form-item>
													</el-col>
													<el-col :span="3">
														<el-form-item>
															<el-select v-model="reviewListParams.disciplineId" clearable placeholder="所属学科">
																<el-option v-for="item in disciplineOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
															</el-select>
														</el-form-item>
													</el-col>
													<el-col :span="3">
														<el-form-item><el-date-picker v-model="reviewListParams.year" value-format="yyyy" type="year" placeholder="立项年度"></el-date-picker></el-form-item>
													</el-col> -->
													<el-col :span="3">
														<el-form-item>
															<el-select v-model="reviewListParams.status" clearable placeholder="审核状态">
																<el-option v-for="item in reviewStatusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
															</el-select>
														</el-form-item>
													</el-col>
													<el-col :span="6">
														<el-form-item>
															<el-button type="primary" @click="searchReviewList">查询</el-button>
															<el-button type="success" @click="exportExcel('school')">导出Excel</el-button>
														</el-form-item>
													</el-col>
												</el-row>
											</el-form>
											
											<!-- <div class="stat mb20">数据统计：未开题：525，已开题：315</div> -->
											
											<el-table id="table" :header-cell-style="tableStyle" :data="reviewList" border style="width: 100%;margin-bottom: 20px;">
												<!-- <el-table-column prop="projectNumber" label="立项编号"></el-table-column> -->
												<el-table-column prop="oldDeclareName" label="课题名称"></el-table-column>
												<el-table-column prop="projectLevelName" label="课题级别"></el-table-column>
												<el-table-column prop="projectTypeName" label="课题类别"></el-table-column>
												<el-table-column prop="applicantName" label="申请人"></el-table-column>
												<el-table-column prop="applicantUnitName" label="申请单位"></el-table-column>
												<el-table-column prop="oneUnitName" label="变更事项">
													<template v-slot="scope">
														{{scope.row | getChange}}
													</template>
												</el-table-column>
												<el-table-column prop="applicantTime" label="申请时间"></el-table-column>
												<el-table-column prop="status" label="审核状态">
													<template v-slot="scope">
														{{ scope.row.status | getStatus}}
													</template>
												</el-table-column>
												<el-table-column prop="address" label="操作">
													<template v-slot="scope">
														<el-button v-if="[0,2].includes(scope.row.status)" type="text" @click="review(scope.row.id)">审核</el-button>
													</template>
												</el-table-column>
											</el-table>
											<div class="pagination">
												<el-pagination
													@size-change="schoolSizeChange"
													@current-change="schoolCurrentChange"
													:current-page="reviewListParams.pageNumber"
													:page-sizes="[10, 20, 50, 100]"
													:page-size="reviewListParams.pageSize"
													layout="total, sizes, prev, pager, next, jumper"
													:total="total"
												></el-pagination>
											</div>
										</div>
										
										<ReviewDetail :reviewType="reviewListParams.type" :topicChangeRecordId="curReviewId" @goBack="goBack" v-if="isShowReviewDetail" />
										
										
									</div>
									<!-- end card-body-->
								</div>
								<!-- end card -->
							</div>
							<!-- end col-->
						</div>
					</div>
				</div>
			</div>
			<!-- end wrapper-->
		</div>
	</div>
</template>

<script>
import Breadcrumb from '../../components/Breadcrumb.vue';
import ReviewDetail from './components/ReviewDetail.vue'
import { getPlatformInformationData } from '@/api/after/systemManagement.js';
import { getTopicChangeRecordReviewList,getReviewDetailById,schoolReviewOrAreaReview } from '@/api/after/topicManage.js';
export default {
	components: {
		Breadcrumb,
		ReviewDetail,
	},
	data() {
		return {
			isShowReviewDetail:false,//控制审核详情的显示和隐藏
			curReviewId:0,//当前审核记录ID
			tableStyle:{
				backgroundColor:'#3083c5',
				color:'#fff',
				textAlign:'center',
			},
			tabList: [],
			curTabIndex:0,//当前tab索引
			reviewListParams:{
				alterationTime:null,//变更时间			
				keyword:null,//关键字			
				keywordId:[],//级别或类别id			
				pageNumber:1,//页码,默认为1,示例值(1)			
				pageSize:10,//页大小,默认为10,示例值(10)			
				status:null,//状态(0:初审未处理,1:初审不通过,2:终审未处理,3终审不通过,4:终审通过)			
				type:0,//类型(0:学校审,1:区审)
			},
			schoolReviewTopicTotal:0,
			TopicLevelTypeList:[],//课题级别类别
			// learningTypeList:[],
			// disciplineOptions:[],
			reviewStatusOptions:[
				{
					label:'初审未处理',
					value:0
				},
				{
					label:'初审不通过',
					value:1
				},
				{
					label:'终审未处理',
					value:2
				},
				{
					label:'终审不通过',
					value:3
				},
				{
					label:'终审通过',
					value:4
				},
			],
			reviewList:[],//评审列表
			total:0,//评审列表总数
			userinfo:{},//用户信息
		}
	},
	filters:{
		// 通过数据来判断课题哪些东西会变更
		getChange(val){
			let isChangeTopicName = Boolean(val.newDeclareName);
			let isChangeOneEmcee = val.newOneEmceeId !== ''
			let isChangeTwoEmcee = val.newTwoEmceeId !== ''
			let isChangeDelayTime = val.month !== '';
			let str = ''
			if (isChangeTopicName) {
				str += '课题名称'
			}else if (isChangeOneEmcee) {
				if (str) {
					str += '、第一负责人'
				}else{
					str += '第一负责人'
				}
			}else if (isChangeTwoEmcee) {
				if (str) {
					str += '、第二负责人'
				}else{
					str += '第二负责人'
				}
			}else if (isChangeDelayTime) {
				if (str) {
					str += '、延迟时间'
				}else{
					str += '延迟时间'
				}
			}
			return str
		},
		// 获取审核状态
		getStatus(val) {
			switch (val) {
				case 0:
					return '初审未处理';
					break;
				case 1:
					return '初审不通过';
					break;
				case 2:
					return '终审未处理';
					break;
				case 3:
					return '终审不通过';
					break;
				case 4:
					return '终审通过';
					break;
				default:
					break;
			}
		},
	},
	created() {
		let userinfo = JSON.parse(sessionStorage.getItem('userInfo'))
		if (userinfo) {
			this.userinfo = userinfo
			//确定用户的审核权限
			if (userinfo.roleId.indexOf('2') >= 0) {
				this.tabList.push('学校审核')
			}
			if (userinfo.roleId.indexOf('5') >= 0) {
				this.tabList.push('区级审核')
			}
			if(userinfo.roleId.indexOf('1') >= 0){
				this.tabList[0] = '学校审核'
				this.tabList[1] = '区级审核'
			}
			//根据用户权限渲染页面
			if (this.tabList.length === 2) {
				this.reviewListParams.type = 0
				this.curTabIndex = 0
			}else if(this.tabList.length === 1){
				if(this.tabList[0] === '学校审核'){
					this.reviewListParams.type = 0
					this.curTabIndex = 0
				}else{
					this.reviewListParams.type = 1
					this.curTabIndex = 0
				}
			}
			this.getTopicChangeRecordReviewList(this.disposeData())
		}
		this.getTopicLevelType()
	},
	methods: {
		review(id){
			this.curReviewId = id
			this.isShowReviewDetail = true
		},
		async getTopicChangeRecordReviewList(data){
			const res = await getTopicChangeRecordReviewList(data)
			if (res.code == 200) {
				console.log('课题变更审核列表',res);
				this.reviewList = res.data.records
				this.total = res.data.total
			}else{
				this.$message.error(res.data)
			}
		},
		// 搜索
		searchReviewList(){
			this.getTopicChangeRecordReviewList(this.disposeData())
		},
		// 处理查询表单数据
		disposeData(){
			let params = JSON.parse(JSON.stringify(this.reviewListParams))
			params.pageNumber = 1
			params.keywordId =params.keywordId.length? params.keywordId[params.keywordId.length-1]:null
			return params
		},
		// 导出Excel
		exportExcel(){
			
		},
		tabChange(index){
			if (this.curTabIndex == index) {
				return 
			}
			this.curTabIndex = index
			this.reviewListParams.type = index
			this.getTopicChangeRecordReviewList(this.disposeData())
		},
		// 获取课题级别类别目录
		async getTopicLevelType() {
			const res = await getPlatformInformationData(1);
			console.log('课题级别类别', res);
			if (res.code == 200) {
				this.TopicLevelTypeList = res.data;
			} else {
				this.$message.error(res.data);
			}
		},
		schoolSizeChange(val){
			this.reviewListParams.pageSize = val
		},
		schoolCurrentChange(val) {
			this.reviewListParams.pageNumber = val
		},
		goBack(){
			this.isShowReviewDetail = false
			this.getTopicChangeRecordReviewList(this.disposeData())
		}
	},
};
</script>

<style scoped lang="scss">
	.tabs_wrap{
		list-style: none;
		padding-left: 0px;
		display: flex;
		align-items: center;
		.tab_item{
			flex: 1;	
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 18px;
			cursor: pointer;
		}
		.tab_item.active{
			color:#00a2e8;
			border-bottom: 1px solid #00a2e8;
		}
	}
</style>
